
import FormInput from '@/components/FormInput/FormInput.vue'
import IconAction from '@/components/IconAction/IconAction.vue'
import UserPicker from '@/components/UserPicker/UserPicker.vue'
import { randomUUID } from '@/models/interface/Common'
import { percentageMask } from '@/models/interface/Masks'
import WebMessage from '@/models/WebMessage'
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator'

@Component({
  components: {
    UserPicker,
    FormInput,
    IconAction,
  },
})
export default class SalesRepShares extends Vue {
  @Prop({ required: false, default: () => [] })
  public value!: any

  @Prop({ default: false })
  public preview!: any

  @Prop({ default: false })
  public hideButton!: any

  public value_limit_reached: boolean = false

  public get local_value() {
    return this.value
  }

  public set local_value(val) {
    this.$emit('input', val)
  }

  public get totalOfAllValues() {
    if (!this.local_value || !this.local_value.length) {
      return 0
    }
    return this.local_value.reduce((acc: any, share: any) => acc + share.percentage, 0)
  }

  public get masks() {
    return {
      percentage: percentageMask,
    }
  }

  public availableShare: number = 99

  public open: boolean = true

  public get remainingShare() {
    return this.availableShare - this.totalOfAllValues
  }

  public get containsZerpValueShare() {
    return this.local_value.some((share: any) => share.percentage === 0)
  }

  @Watch('totalOfAllValues')
  public onTotalOfAllValuesChange(val: any) {
    if (val > this.availableShare) {
      this.value_limit_reached = true
    } else {
      this.value_limit_reached = false
    }
  }

  @Watch('value_limit_reached')
  public onValueLimitReachedChange(val: boolean) {
    const saveButton = document.getElementById('navigate-save')
    if (val) {
      if (saveButton) {
        saveButton.setAttribute('disabled', 'true')
      }
      this.$emit('setErrors', {
        secondary_sales_rep_ids: ['Total percentage of shares exceeds available share.'],
      })
    } else {
      this.$emit('setErrors', { secondary_sales_rep_ids: [] })
      if (saveButton) {
        saveButton.removeAttribute('disabled')
      }
    }
  }

  public setNewShare() {
    this.local_value.push({
      id: randomUUID(),
      sales_rep_id: null,
      percentage: 0,
      new: true,
    })

    setTimeout(() => {
      const container = this.$el.querySelector('.share-container')
      if (container) {
        container.scrollTop = container.scrollHeight
      }
    }, 300)
  }

  public remove(index: number) {
    this.local_value.splice(index, 1)
  }

  public confirmIfNeeded(isNew: boolean, exe: any) {
    if (isNew) {
      exe()
      return
    }
    WebMessage.doubleConfirm(
      'Are you sure you want to remove this Share?',
      'Remove Share',
      'Yes, Remove Share',
    ).then((res: any) => {
      if (res) {
        exe()
      }
    })
  }
}
